/**
 * @generated SignedSource<<4ad2240686d2ffbf3ea8dec779e526e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoListItemStatus_todo$data = {
  readonly status: WorkspaceTodoStatus;
  readonly todoCount: number;
  readonly todosCompletedCount: number;
  readonly " $fragmentType": "WorkspaceTodoListItemStatus_todo";
};
export type WorkspaceTodoListItemStatus_todo$key = {
  readonly " $data"?: WorkspaceTodoListItemStatus_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItemStatus_todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoListItemStatus_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "todoCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "todosCompletedCount",
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "dc8fe2d8b7f5d04229732e9782272ca5";

export default node;
